import React, { ReactNode, useState, useContext } from "react";

import DataTable, { Row, Column } from "components/DataTable";
import HeaderButtons from "components/Button/HeaderButtons";
import { AiOutlineExport } from "react-icons/ai";
import apiService from "services/apiService";
import { BannerContext } from "components/SideBar";
interface InventoryItem extends Row {
  id: number;
  asset_type?: string;
  status?: string;
}

interface InventoriesListProps {
  data: InventoryItem[];
  columns: Column[];
  onAdd?: () => void;
  loading?: boolean;
  selectedInventory: string;
  onRequestAsset: () => void;
  leftSideButtons?: ReactNode;
  itemsPerPage?: number;
  currentPage?: number;
  totalItems?: number;
  onPageChange?: (page: number) => void;
  onItemsPerPageChange?: (itemsPerPage: number) => void;
  onSearchTermChange?: (searchTerm: string) => void;
  exportParams?: Record<string, string | number | undefined>;
}

export const tableHeight = "h-[calc(100vh-200px)] min-h-[200px]";
export const userTableHeight = "h-[calc(100vh-230px)] min-h-[200px]";


const InventoriesList: React.FC<InventoriesListProps> = ({
  data,
  columns,
  onAdd,
  loading,
  onRequestAsset,
  leftSideButtons,
  itemsPerPage,
  currentPage,
  totalItems,
  onPageChange,
  onItemsPerPageChange,
  onSearchTermChange,
  exportParams,
  // selectedInventory 
}) => {
  // const { t } = useTranslation();
  const [isExporting, setIsExporting] = useState(false);
  const { isBannerVisible } = useContext(BannerContext);

  const dynamicHeightClass = isBannerVisible
    ? "h-[calc(100vh-146px)] min-h-[300px]"
    : "h-[calc(100vh-115px)] min-h-[300px]";
  const handleExport = async () => {
    if (isExporting) return;

    const query = new URLSearchParams();
    if (exportParams) {
      Object.entries(exportParams).forEach(([key, value]) => {
        if (value !== undefined && value !== "") {
          query.set(key, String(value));
        }
      });
    }

    setIsExporting(true);
    try {
      const url = query.toString()
        ? `/api/assets/export?${query.toString()}`
        : "/api/assets/export";

      const response = await apiService.get(url, { responseType: "blob" });
      const blob =
        response.data instanceof Blob
          ? response.data
          : new Blob([response.data], {
            type: "application/vnd.ms-excel",
          });

      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = `inventory-export-${new Date().toISOString().slice(0, 10)}.xls`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error("Failed to export inventory data", error);
    } finally {
      setIsExporting(false);
    }
  };



  return (
    <div className="flex flex-col  font-sans antialiased text-slate-800 dark:text-slate-200 transition-colors duration-300">





      {/* DATA TABLE WRAPPER */}
      <DataTable
        data={data}
        columns={columns}
        loading={loading}
        onAddBtnClick={onAdd}
        itemsPerPage={itemsPerPage}
        serverSidePagination
        currentPage={currentPage}
        totalItems={totalItems}
        onPageChange={onPageChange}
        onItemsPerPageChange={onItemsPerPageChange}
        onSearchTermChange={onSearchTermChange}
        searchPlaceholder="Search"
        headerLabelClassName="font-medium"
        heightClass={dynamicHeightClass}
        // heightClass="h-[calc(100vh-146px)] min-h-[300px]"
        paginationContainerClassName="pt-10"
        preAddButtons={
          <button
            type="button"
            onClick={handleExport}
            disabled={isExporting}
            className="text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 hover:bg-slate-50 dark:hover:bg-slate-700 disabled:opacity-60 disabled:cursor-not-allowed shadow-sm font-medium rounded-lg text-sm px-4 py-2.5 inline-flex items-center border-radius-0.5rem"
          >
            <AiOutlineExport size={18} className="mr-1.5" />
            {isExporting ? "Exporting..." : "Export"}
          </button>
        }
        customButton={
          <HeaderButtons
            type="button"
            onClick={onRequestAsset}
            className="w-32 "
          >
            Request
          </HeaderButtons>}
        leftSideButtons={leftSideButtons}

      />
    </div>
  );
};

export default InventoriesList;